import { MutationTree, ActionTree, ActionContext, GetterTree } from "vuex";
import { RootState } from "@/store";

export interface BookingState {
  bookingDetails: any;
  paymentCreditCard?: any;
  redeemData: any;
}

type AppContext = ActionContext<BookingState, RootState>;

export const namespaced = true;

export const state = (): BookingState => ({
  bookingDetails: {
    id: null,
    aasmState: null,
    adults: null,
    children: null,
    startAt: null,
    duration: null,
    language: null,
    giftId: null,
    redeem: null,
    time: null,
    timetable: null,
    pricePerPerson: null,
    priceCurrency: null,
    priceLabel: null,
    price2Label: null,
    total: 0,
    experienceId: null,
    experience: null,
    priceLabels: [],
    priceExtras: [],
  },
  paymentCreditCard: {
    card: null,
    form: null
  },
  redeemData: null
});

export const getters: GetterTree<BookingState, RootState> = {};

export const mutations: MutationTree<BookingState> = {
  setBookingDetails(state: BookingState, form: any) {
    if (form.adults || form.adults === 0)
      state.bookingDetails.adults = form.adults;
    if (form.children || form.children === 0)
      state.bookingDetails.children = form.children;
    if (form.startAt) state.bookingDetails.startAt = form.startAt;
    if (form.duration) state.bookingDetails.duration = form.duration;
    if (form.language) state.bookingDetails.language = form.language;
    if (form.time) state.bookingDetails.time = form.time;
    if (form.timetable) state.bookingDetails.timetable = form.timetable;
    if (form.pricePerPerson || form.pricePerPerson === 0)
      state.bookingDetails.pricePerPerson = form.pricePerPerson;
    if (form.priceCurrency)
      state.bookingDetails.priceCurrency = form.priceCurrency;
    if (form.priceLabel) state.bookingDetails.priceLabel = form.priceLabel;
    state.bookingDetails.isGift = form.isGift || false;
    if (form.giftId) state.bookingDetails.giftId = form.giftId;
    if (form.redeem) state.bookingDetails.redeem = form.redeem;
    if (form.price2Label) state.bookingDetails.price2Label = form.price2Label;
    if (form.total) {
      state.bookingDetails.total = form.total;
    }
    if (form.experienceId)
      state.bookingDetails.experienceId = form.experienceId;
    if (form.experience) state.bookingDetails.experience = form.experience;
    state.bookingDetails.priceLabels = form.priceLabels;
    state.bookingDetails.priceExtras = form.priceExtras;
  },
  resetBookingDetails(state: BookingState) {
    state.bookingDetails.adults = 0;
    state.bookingDetails.children = 0;
    state.bookingDetails.startAt = null;
    state.bookingDetails.duration = null;
    state.bookingDetails.language = null;
    state.bookingDetails.time = null;
    state.bookingDetails.timetable = null;
    state.bookingDetails.pricePerPerson = null;
    state.bookingDetails.priceCurrency = null;
    state.bookingDetails.isGift = null;
    state.bookingDetails.giftId = null;
    state.bookingDetails.redeem = null;
    state.bookingDetails.priceLabel = null;
    state.bookingDetails.price2Label = null;
    state.bookingDetails.total = 0;
    state.bookingDetails.experienceId = null;
    state.bookingDetails.experience = null;
    state.bookingDetails.priceLabels = [];
    state.bookingDetails.priceExtras = [];
  },
  setCard(state: BookingState, card: any) {
    state.paymentCreditCard.card = card;
  },
  setForm(state: BookingState, form: any) {
    state.paymentCreditCard.form = form;
  },

  updateQtdPriceLabelsByIndex(state: BookingState, options: {index: number, value: number}) {
    state.bookingDetails.priceLabels[options.index].quantity = options.value
  },

  updateQtdPriceExtrasByIndex(state: BookingState, options: {index: number, value: number}) {
    state.bookingDetails.priceExtras[options.index].quantity = options.value
  },
  setRedeemData(state: BookingState, data: any) {
    state.redeemData = data;
  },

  clearRedeemData(state: BookingState) {
    state.redeemData = null;
  }
};

export const actions: ActionTree<BookingState, RootState> = {
  setExperience(context: AppContext, data: any) {
    if (data) context.commit("setExperience", data);
  },
  setBookingDetails(context: AppContext, data: any) {
    console.warn('data')
    console.warn(data)
    if (data) context.commit("setBookingDetails", data);
  },
  resetBookingDetails(context: AppContext) {
    context.commit("resetBookingDetails");
  },
  setPaymentCard(context: AppContext, data: any) {
    context.commit("setCard", data);
  },
  setPaymentForm(context: AppContext, data: any) {
    context.commit("setForm", data);
  },
  updateQtdPriceLabelsByIndex(context: AppContext, data: any) {
    context.commit("updateQtdPriceLabelsByIndex", data);
  },
  updateQtdPriceExtrasByIndex(context: AppContext, data: any) {
    context.commit("updateQtdPriceExtrasByIndex", data);
  },
  setRedeemData({ commit }: AppContext, data: any) {
    commit('setRedeemData', data);
  },
  clearRedeemData({ commit }: AppContext) {
    commit('clearRedeemData');
  }
};
